/* ============================================
   Coaster Design Studio — Fabric.js v7 Engine
   3 Blades Maker Lab
   ============================================ */

(function () {
  'use strict';

  var CANVAS_SIZE = window.innerWidth > 768 ? 600 : 400;
  var CANVAS_PADDING = 20;
  var SLATE_COLORS = { 'Black': '#2d2d2d', 'Green': '#2d4a3a' };
  var SLATE_TEXTURES = {
    'Square-Black': 'slate-blank-square-black.jpg',
    'Square-Green': 'slate-blank-square-green.jpg',
    'Round-Black': 'slate-blank-round-black.jpg',
    'Round-Green': 'slate-blank-round-green.jpg'
  };
  var slateTextureBaseUrl = window.slateTextureBaseUrl || '';
  var ENGRAVING_COLOR = '#ffffff';
  var DEFAULT_FONT = 'Cinzel';

  var canvas;
  var coasterBg;
  var textBoxCount = 0;
  var currentOptions = { option1: null, option2: null, option3: null };
  var productData;
  var selectedFont = DEFAULT_FONT;

  /* --- Init --- */
  function init() {
    try {
      var dataEl = document.getElementById('customizer-product-data');
      if (!dataEl) return;
      productData = JSON.parse(dataEl.textContent);

      document.querySelectorAll('.customizer-option-btn--active').forEach(function (btn) {
        currentOptions['option' + btn.dataset.option] = btn.dataset.value;
      });

      initCanvas();
      initTabs();
      initFontPicker();
      initAddTextButton();
      initTextControls();
      initImageUpload();
      initClipart();
      initOptionButtons();
      initActions();
      initMobileTabs();
      initMobileDeleteButton();
      updateVariant();
      console.log('Coaster customizer initialized');
    } catch (err) {
      console.error('Customizer init error:', err);
    }
  }

  /* --- Canvas --- */
  function initCanvas() {
    var el = document.getElementById('coasterCanvas');
    if (!el) return;
    canvas = new fabric.Canvas(el, {
      width: CANVAS_SIZE, height: CANVAS_SIZE,
      backgroundColor: '#111',
      selection: true,
      preserveObjectStacking: true
    });
    renderCoasterShape();
    canvas.on('object:modified', updateDesignState);
    canvas.on('object:added', updateDesignState);
    canvas.on('object:removed', updateDesignState);
  }

  function renderCoasterShape() {
    if (coasterBg) canvas.remove(coasterBg);
    var isRound = currentOptions.option2 && currentOptions.option2.indexOf('Round') !== -1;
    var color = SLATE_COLORS[currentOptions.option3] || SLATE_COLORS['Black'];
    var colorName = currentOptions.option3 || 'Black';
    var center = CANVAS_SIZE / 2;
    var size = CANVAS_SIZE - CANVAS_PADDING * 2;

    if (isRound) {
      canvas.clipPath = new fabric.Circle({
        radius: size / 2, left: center, top: center,
        originX: 'center', originY: 'center', absolutePositioned: true
      });
    } else {
      canvas.clipPath = new fabric.Rect({
        width: size, height: size, left: center, top: center,
        originX: 'center', originY: 'center', rx: 4, ry: 4, absolutePositioned: true
      });
    }

    // Try to load real slate texture
    var shapeKey = isRound ? 'Round' : 'Square';
    var textureFile = SLATE_TEXTURES[shapeKey + '-' + colorName];
    var textureUrl = slateTextureBaseUrl ? slateTextureBaseUrl + textureFile : null;

    if (textureUrl) {
      fabric.FabricImage.fromURL(textureUrl, { crossOrigin: 'anonymous' }).then(function (img) {
        img.set({
          left: center, top: center, originX: 'center', originY: 'center',
          selectable: false, evented: false,
          scaleX: size / img.width, scaleY: size / img.height
        });
        coasterBg = img;
        canvas.insertAt(0, coasterBg);
        canvas.requestRenderAll();
      }).catch(function () {
        // Fallback to flat color
        renderCoasterShapeFallback(isRound, color, center, size);
      });
    } else {
      renderCoasterShapeFallback(isRound, color, center, size);
    }
  }

  function renderCoasterShapeFallback(isRound, color, center, size) {
    if (isRound) {
      coasterBg = new fabric.Circle({
        radius: size / 2, fill: color,
        left: center, top: center, originX: 'center', originY: 'center',
        selectable: false, evented: false, strokeWidth: 2, stroke: '#444'
      });
    } else {
      coasterBg = new fabric.Rect({
        width: size, height: size, fill: color,
        left: center, top: center, originX: 'center', originY: 'center',
        rx: 4, ry: 4, selectable: false, evented: false, strokeWidth: 2, stroke: '#444'
      });
    }
    canvas.insertAt(0, coasterBg);
    canvas.requestRenderAll();
  }

  /* --- Mobile: Switch to Preview tab --- */
  function switchToPreviewOnMobile() {
    if (window.innerWidth > 768) return;
    var previewTab = document.querySelector('.customizer-mobile-tab[data-mobile-tab="canvas"]');
    if (previewTab) previewTab.click();
  }

  /* --- Mobile: Floating delete button on canvas --- */
  function initMobileDeleteButton() {
    var canvasArea = document.getElementById('canvasArea');
    if (!canvasArea) return;

    var delBtn = document.createElement('button');
    delBtn.type = 'button';
    delBtn.id = 'mobileDeleteSelected';
    delBtn.textContent = 'Delete Selected';
    delBtn.style.cssText = 'display:none;position:absolute;top:10px;right:10px;z-index:10;padding:6px 14px;border:none;border-radius:6px;background:rgba(192,57,43,0.9);color:#fff;font-size:12px;font-weight:600;cursor:pointer;backdrop-filter:blur(4px);';
    canvasArea.style.position = 'relative';
    canvasArea.appendChild(delBtn);

    delBtn.addEventListener('click', function () {
      var active = canvas.getActiveObject();
      if (active && active !== coasterBg) {
        canvas.remove(active);
        canvas.discardActiveObject();
        canvas.requestRenderAll();
      }
    });

    // Show/hide based on selection
    canvas.on('selection:created', function () {
      if (window.innerWidth <= 768) delBtn.style.display = 'block';
    });
    canvas.on('selection:updated', function () {
      if (window.innerWidth <= 768) delBtn.style.display = 'block';
    });
    canvas.on('selection:cleared', function () {
      delBtn.style.display = 'none';
    });
  }

  /* --- Tabs --- */
  function initTabs() {
    document.querySelectorAll('.customizer-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        document.querySelectorAll('.customizer-tab').forEach(function (t) { t.classList.remove('customizer-tab--active'); });
        document.querySelectorAll('.customizer-tab-content').forEach(function (c) { c.classList.remove('customizer-tab-content--active'); });
        tab.classList.add('customizer-tab--active');
        var target = document.getElementById('tab-' + tab.dataset.tab);
        if (target) target.classList.add('customizer-tab-content--active');
      });
    });
  }

  /* --- Font Picker --- */
  function initFontPicker() {
    var btn = document.getElementById('fontPickerBtn');
    var dropdown = document.getElementById('fontDropdown');
    if (!btn || !dropdown) return;

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      dropdown.classList.toggle('customizer-font-picker__dropdown--open');
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.customizer-font-picker')) {
        dropdown.classList.remove('customizer-font-picker__dropdown--open');
      }
    });

    document.querySelectorAll('.customizer-font-picker__option').forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        e.stopPropagation();
        var font = opt.dataset.font;
        selectedFont = font;

        document.querySelectorAll('.customizer-font-picker__option').forEach(function (o) { o.classList.remove('customizer-font-picker__option--active'); });
        opt.classList.add('customizer-font-picker__option--active');
        btn.querySelector('.customizer-font-picker__preview').style.fontFamily = "'" + font + "', serif";
        btn.querySelector('.customizer-font-picker__preview').textContent = font;

        // Apply to currently selected text object
        var active = canvas.getActiveObject();
        if (active && (active.type === 'textbox' || active.type === 'i-text' || active.type === 'text')) {
          active.set('fontFamily', font);
          canvas.requestRenderAll();
        }

        dropdown.classList.remove('customizer-font-picker__dropdown--open');
      });
    });
  }

  /* --- Add Text Box Button --- */
  function initAddTextButton() {
    var btn = document.getElementById('addTextBtn');
    if (!btn) return;

    btn.addEventListener('click', function () {
      textBoxCount++;
      var yOffset = 0.3 + (textBoxCount % 4) * 0.15;
      var newText = new fabric.Textbox('Your Text', {
        left: CANVAS_SIZE / 2,
        top: CANVAS_SIZE * Math.min(yOffset, 0.75),
        originX: 'center',
        originY: 'center',
        fontFamily: selectedFont,
        fontSize: 28,
        fill: ENGRAVING_COLOR,
        textAlign: 'center',
        width: CANVAS_SIZE - CANVAS_PADDING * 4,
        editable: true
      });
      canvas.add(newText);
      canvas.setActiveObject(newText);
      canvas.requestRenderAll();
      switchToPreviewOnMobile();
    });
  }

  /* --- Text Controls (size slider, center, delete) --- */
  function initTextControls() {
    var sizeSlider = document.getElementById('textSize');
    if (sizeSlider) {
      sizeSlider.addEventListener('input', function () {
        var active = canvas.getActiveObject();
        if (active && (active.type === 'textbox' || active.type === 'i-text' || active.type === 'text')) {
          active.set('fontSize', parseInt(sizeSlider.value));
          canvas.requestRenderAll();
        }
      });
    }

    // Update slider when selecting a text object
    canvas.on('selection:created', syncSliderToSelection);
    canvas.on('selection:updated', syncSliderToSelection);

    function syncSliderToSelection(e) {
      var obj = e.selected ? e.selected[0] : null;
      if (obj && (obj.type === 'textbox' || obj.type === 'i-text' || obj.type === 'text') && sizeSlider) {
        sizeSlider.value = obj.fontSize || 28;
      }
    }
  }

  /* --- Image Upload --- */
  function initImageUpload() {
    var fileInput = document.getElementById('imageUpload');
    if (!fileInput) return;

    fileInput.addEventListener('change', function (e) {
      var file = e.target.files[0];
      if (!file) return;

      var reader = new FileReader();
      reader.onload = function (ev) {
        fabric.Image.fromURL(ev.target.result).then(function (fabricImg) {
          fabricImg.set({
            left: CANVAS_SIZE / 2, top: CANVAS_SIZE / 2,
            originX: 'center', originY: 'center'
          });
          var maxSize = CANVAS_SIZE * 0.5;
          var scale = Math.min(maxSize / fabricImg.width, maxSize / fabricImg.height);
          fabricImg.scale(scale);
          fabricImg.filters = [
            new fabric.filters.Grayscale(),
            new fabric.filters.Brightness({ brightness: 0.3 })
          ];
          fabricImg.applyFilters();
          canvas.add(fabricImg);
          canvas.setActiveObject(fabricImg);
          canvas.requestRenderAll();
          document.getElementById('propDesignSource').value = 'custom-upload';
          switchToPreviewOnMobile();
        }).catch(function (err) { console.error('Image load error:', err); });
      };
      reader.readAsDataURL(file);
      fileInput.value = '';
    });
  }

  /* --- Clipart (Noun Project Catalog) --- */
  function initClipart() {
    var catalogEl = document.getElementById('clipart-catalog');
    if (!catalogEl) return;
    var catalog;
    try { catalog = JSON.parse(catalogEl.textContent); } catch (e) { return; }

    var grid = document.getElementById('clipartGrid');
    if (!grid) return;

    // Check if catalog is categorized (object) or flat (array)
    var isCategories = !Array.isArray(catalog);

    if (isCategories) {
      // Build category selector
      var catNames = Object.keys(catalog);
      var catSelector = document.createElement('div');
      catSelector.className = 'customizer-clipart-categories';

      catNames.forEach(function (name, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'customizer-clipart-cat' + (i === 0 ? ' customizer-clipart-cat--active' : '');
        btn.textContent = name;
        btn.addEventListener('click', function () {
          catSelector.querySelectorAll('.customizer-clipart-cat').forEach(function (b) { b.classList.remove('customizer-clipart-cat--active'); });
          btn.classList.add('customizer-clipart-cat--active');
          renderClipartGrid(catalog[name], grid);
        });
        catSelector.appendChild(btn);
      });

      grid.parentElement.insertBefore(catSelector, grid);
      renderClipartGrid(catalog[catNames[0]], grid);
    } else {
      renderClipartGrid(catalog, grid);
    }
  }

  function renderClipartGrid(icons, grid) {
    grid.innerHTML = '';
    icons.forEach(function (item) {
      var el = document.createElement('button');
      el.type = 'button';
      el.className = 'customizer-clipart-item';
      el.title = item.term || item.name || '';

      if (item.thumbnail) {
        el.innerHTML = '<img src="' + item.thumbnail + '" alt="' + (item.term || '') + '" loading="lazy">';
      } else {
        el.innerHTML = '<span class="customizer-clipart-item__name">' + (item.term || item.name || '') + '</span>';
      }

      el.addEventListener('click', function () {
        addClipartToCanvas(item);
      });
      grid.appendChild(el);
    });
  }

  function addClipartToCanvas(item) {
    if (!item.thumbnail) return;

    // Proxy through weserv.nl to add CORS headers (Noun Project CDN has no CORS)
    // Also invert colors via the proxy: &filt=negate turns black→white
    var proxyUrl = 'https://images.weserv.nl/?url=' + encodeURIComponent(item.thumbnail) + '&filt=negate';

    var img = new Image();
    img.crossOrigin = 'anonymous';

    img.onload = function () {
      var fabricImg = new fabric.Image(img, {
        left: CANVAS_SIZE / 2, top: CANVAS_SIZE / 2,
        originX: 'center', originY: 'center'
      });

      var maxSize = CANVAS_SIZE * 0.4;
      var scale = Math.min(maxSize / fabricImg.width, maxSize / fabricImg.height);
      fabricImg.scale(scale);

      canvas.add(fabricImg);
      canvas.setActiveObject(fabricImg);
      canvas.requestRenderAll();
      switchToPreviewOnMobile();

      var attribution = item.attribution || ('Icon: ' + (item.term || ''));
      document.getElementById('propDesignSource').value = attribution;
    };

    img.onerror = function () {
      console.error('Failed to load icon:', item.thumbnail, '- trying direct...');
      // Fallback: try loading directly without CORS (won't be able to export but at least shows)
      var img2 = new Image();
      img2.onload = function () {
        var fabricImg = new fabric.Image(img2, {
          left: CANVAS_SIZE / 2, top: CANVAS_SIZE / 2,
          originX: 'center', originY: 'center'
        });
        var maxSize = CANVAS_SIZE * 0.4;
        var scale = Math.min(maxSize / fabricImg.width, maxSize / fabricImg.height);
        fabricImg.scale(scale);
        canvas.add(fabricImg);
        canvas.setActiveObject(fabricImg);
        canvas.requestRenderAll();
        switchToPreviewOnMobile();
      };
      img2.src = item.thumbnail;
    };

    img.src = proxyUrl;
  }

  /* --- Option Buttons --- */
  function initOptionButtons() {
    document.querySelectorAll('.customizer-option-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var optNum = btn.dataset.option;
        var value = btn.dataset.value;
        btn.parentElement.querySelectorAll('.customizer-option-btn').forEach(function (b) { b.classList.remove('customizer-option-btn--active'); });
        btn.classList.add('customizer-option-btn--active');
        currentOptions['option' + optNum] = value;
        if (optNum === '2') renderCoasterShape();
        if (optNum === '3') {
          renderCoasterShape();
        }
        updateVariant();
      });
    });
  }

  function updateVariant() {
    if (!productData) return;
    var variant = productData.variants.find(function (v) {
      return v.option1 === currentOptions.option1 &&
        v.option2 === currentOptions.option2 &&
        v.option3 === currentOptions.option3;
    });
    if (variant) {
      document.getElementById('variantId').value = variant.id;
      var priceStr = '$' + (variant.price / 100).toFixed(2);
      document.getElementById('priceAmount').textContent = priceStr;
      var mp = document.getElementById('mobilePriceAmount');
      if (mp) mp.textContent = priceStr;
    }
  }

  /* --- Actions --- */
  var miniCartItems = []; // track items added in this session

  function initActions() {
    // Center selected
    var centerBtn = document.getElementById('centerTextBtn');
    if (centerBtn) {
      centerBtn.addEventListener('click', function () {
        var active = canvas.getActiveObject();
        if (active && active !== coasterBg) {
          active.set({ left: CANVAS_SIZE / 2, originX: 'center' });
          canvas.requestRenderAll();
        }
      });
    }

    // Delete selected (text tab)
    var deleteBtn = document.getElementById('deleteSelectedBtn');
    if (deleteBtn) {
      deleteBtn.addEventListener('click', deleteSelected);
    }

    // Delete selected (images tab)
    var deleteImgBtn = document.getElementById('deleteSelectedImgBtn');
    if (deleteImgBtn) {
      deleteImgBtn.addEventListener('click', deleteSelected);
    }

    // Clear design
    var clearBtn = document.getElementById('clearDesignBtn');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        var objects = canvas.getObjects().slice();
        objects.forEach(function (obj) { if (obj !== coasterBg) canvas.remove(obj); });
        textBoxCount = 0;
        document.getElementById('propDesignSource').value = 'custom';
        var nameField = document.getElementById('designName');
        if (nameField) nameField.value = '';
        canvas.requestRenderAll();
      });
    }

    // Keyboard delete
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Delete' || e.key === 'Backspace') {
        var tag = e.target.tagName.toLowerCase();
        if (tag === 'input' || tag === 'textarea') return;
        deleteSelected();
        e.preventDefault();
      }
    });

    // Prevent form submit
    var form = document.getElementById('customizerForm');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); });

    // Add to Cart & Design Another
    var addAndDesignBtn = document.getElementById('addAndDesignBtn');
    if (addAndDesignBtn) addAndDesignBtn.addEventListener('click', function () { addToCart(false); });

    // Add to Cart & Finish
    var addAndFinishBtn = document.getElementById('addAndFinishBtn');
    if (addAndFinishBtn) addAndFinishBtn.addEventListener('click', function () { addToCart(true); });

    // Mobile button → finish
    var mobileBtn = document.getElementById('mobileAddToCartBtn');
    if (mobileBtn) mobileBtn.addEventListener('click', function () { addToCart(true); });

    // Load existing mini cart on init
    loadMiniCart();
  }

  function deleteSelected() {
    var active = canvas.getActiveObject();
    if (active && active !== coasterBg) {
      canvas.remove(active);
      canvas.discardActiveObject();
      canvas.requestRenderAll();
    }
  }

  function collectDesignData() {
    canvas.discardActiveObject();
    canvas.requestRenderAll();

    var texts = [];
    var fonts = [];
    canvas.getObjects().forEach(function (obj) {
      if (obj !== coasterBg && (obj.type === 'textbox' || obj.type === 'i-text' || obj.type === 'text')) {
        if (obj.text && obj.text.trim() && obj.text !== 'Your Text') {
          texts.push(obj.text.trim());
        }
        if (obj.fontFamily && fonts.indexOf(obj.fontFamily) === -1) {
          fonts.push(obj.fontFamily);
        }
      }
    });

    document.getElementById('propTextContent').value = texts.join(' | ');
    document.getElementById('propFontsUsed').value = fonts.join(', ');

    var previewDataUrl = canvas.toDataURL({ format: 'jpeg', quality: 0.7, multiplier: 1 });
    document.getElementById('propDesignPreview').value = previewDataUrl;
    document.getElementById('propDesignJSON').value = JSON.stringify(canvas.toJSON(['fontFamily']));

    var variantId = parseInt(document.getElementById('variantId').value);
    var properties = {};
    document.querySelectorAll('#customizerForm input[name^="properties"], #customizerForm textarea[name^="properties"]').forEach(function (input) {
      var match = input.name.match(/\[(.+)\]/);
      if (match && input.value) properties[match[1]] = input.value;
    });

    return { variantId: variantId, properties: properties, previewDataUrl: previewDataUrl };
  }

  function addToCart(goToCart) {
    var addDesignBtn = document.getElementById('addAndDesignBtn');
    var addFinishBtn = document.getElementById('addAndFinishBtn');
    var mobileBtn = document.getElementById('mobileAddToCartBtn');
    addDesignBtn.disabled = true;
    addFinishBtn.disabled = true;
    if (mobileBtn) mobileBtn.disabled = true;

    var targetBtn = goToCart ? addFinishBtn : addDesignBtn;
    var targetText = targetBtn.querySelector('span');
    var origText = targetText.textContent;
    targetText.textContent = 'Adding...';

    setTimeout(function () {
      var data = collectDesignData();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: data.variantId, quantity: 1, properties: data.properties }] })
      })
        .then(function (res) { if (!res.ok) throw new Error('Cart error'); return res.json(); })
        .then(function () {
          // Get design name for display
          var nameField = document.getElementById('designName');
          var designName = (nameField && nameField.value.trim()) ? nameField.value.trim() : ('Design ' + (miniCartItems.length + 1));

          // Track in mini cart
          miniCartItems.push({
            name: designName,
            options: currentOptions.option1 + ' / ' + currentOptions.option2 + ' / ' + currentOptions.option3,
            preview: data.previewDataUrl
          });
          renderMiniCart();

          // Show toast
          showToast('"' + designName + '" added to cart!');

          if (goToCart) {
            setTimeout(function () { window.location.href = '/cart'; }, 800);
          } else {
            // Reset buttons but keep design on canvas
            targetText.textContent = origText;
            addDesignBtn.disabled = false;
            addFinishBtn.disabled = false;
            if (mobileBtn) mobileBtn.disabled = false;

            // Clear just the design name for the next one
            if (nameField) nameField.value = '';
          }
        })
        .catch(function (err) {
          console.error('Add to cart failed:', err);
          targetText.textContent = 'Error - try again';
          setTimeout(function () {
            targetText.textContent = origText;
            addDesignBtn.disabled = false;
            addFinishBtn.disabled = false;
            if (mobileBtn) mobileBtn.disabled = false;
          }, 2000);
        });
    }, 100);
  }

  /* --- Toast Notification --- */
  function showToast(message) {
    var toast = document.getElementById('cartToast');
    var toastText = document.getElementById('cartToastText');
    if (!toast) return;
    toastText.textContent = message;
    toast.style.display = 'block';
    setTimeout(function () { toast.style.display = 'none'; }, 3000);
  }

  /* --- Mini Cart --- */
  function loadMiniCart() {
    // Fetch current cart to show existing items
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.items && cart.items.length > 0) {
          // Show items that have a Design Preview (i.e. customizer items)
          cart.items.forEach(function (item) {
            if (item.properties && item.properties['_Design Preview']) {
              miniCartItems.push({
                name: item.properties['Design Name'] || item.title,
                options: item.variant_title,
                preview: item.properties['_Design Preview'],
                cartKey: item.key
              });
            }
          });
          if (miniCartItems.length > 0) renderMiniCart();
        }
      })
      .catch(function () { /* ignore */ });
  }

  function renderMiniCart() {
    var container = document.getElementById('miniCart');
    var itemsEl = document.getElementById('miniCartItems');
    var countEl = document.getElementById('miniCartCount');
    if (!container) return;

    if (miniCartItems.length === 0) {
      container.style.display = 'none';
      return;
    }

    container.style.display = 'block';
    countEl.textContent = miniCartItems.length + ' design' + (miniCartItems.length > 1 ? 's' : '');
    itemsEl.innerHTML = '';

    miniCartItems.forEach(function (item, index) {
      var row = document.createElement('div');
      row.style.cssText = 'display:flex;align-items:center;gap:0.5rem;padding:0.4rem 0;border-bottom:1px solid #eee;';

      // Thumbnail
      if (item.preview && item.preview.indexOf('data:') === 0) {
        var thumb = document.createElement('img');
        thumb.src = item.preview;
        thumb.style.cssText = 'width:36px;height:36px;border-radius:4px;object-fit:cover;flex-shrink:0;';
        row.appendChild(thumb);
      }

      // Info
      var info = document.createElement('div');
      info.style.cssText = 'flex:1;min-width:0;';
      info.innerHTML = '<div style="font-size:0.8rem;font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' + item.name + '</div>' +
        '<div style="font-size:0.7rem;color:#888;">' + item.options + '</div>';
      row.appendChild(info);

      // Remove button
      var removeBtn = document.createElement('button');
      removeBtn.textContent = '\u00d7';
      removeBtn.style.cssText = 'background:none;border:none;color:#c00;cursor:pointer;font-size:1.1rem;padding:0 0.25rem;line-height:1;flex-shrink:0;';
      removeBtn.setAttribute('data-index', index);
      removeBtn.addEventListener('click', function () {
        var idx = parseInt(this.getAttribute('data-index'), 10);
        var removed = miniCartItems[idx];
        miniCartItems.splice(idx, 1);
        // Try to remove from Shopify cart if it has a key
        if (removed.cartKey) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: removed.cartKey, quantity: 0 })
          }).catch(function () {});
        }
        renderMiniCart();
      });
      row.appendChild(removeBtn);

      itemsEl.appendChild(row);
    });
  }

  /* --- Design State --- */
  function updateDesignState() {
    var hasContent = canvas.getObjects().some(function (obj) { return obj !== coasterBg; });
    var addDesignBtn = document.getElementById('addAndDesignBtn');
    var addFinishBtn = document.getElementById('addAndFinishBtn');
    var mobileBtn = document.getElementById('mobileAddToCartBtn');
    var hint = document.getElementById('cartHint');
    if (addDesignBtn) addDesignBtn.disabled = !hasContent;
    if (addFinishBtn) addFinishBtn.disabled = !hasContent;
    if (mobileBtn) mobileBtn.disabled = !hasContent;
    if (hint) hint.style.display = hasContent ? 'none' : 'block';
  }

  /* --- Mobile Tabs --- */
  function initMobileTabs() {
    document.querySelectorAll('.customizer-mobile-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.dataset.mobileTab;
        document.querySelectorAll('.customizer-mobile-tab').forEach(function (t) { t.classList.remove('customizer-mobile-tab--active'); });
        tab.classList.add('customizer-mobile-tab--active');
        document.querySelector('.customizer-panel--left').classList.remove('mobile-visible');
        document.querySelector('.customizer-panel--right').classList.remove('mobile-visible');
        document.querySelector('.customizer-canvas-area').classList.remove('mobile-hidden');
        if (target === 'text' || target === 'images') {
          document.querySelector('.customizer-panel--left').classList.add('mobile-visible');
          document.querySelector('.customizer-canvas-area').classList.add('mobile-hidden');
          document.querySelectorAll('.customizer-tab').forEach(function (t) { t.classList.remove('customizer-tab--active'); });
          document.querySelectorAll('.customizer-tab-content').forEach(function (c) { c.classList.remove('customizer-tab-content--active'); });
          var tabBtn = document.querySelector('.customizer-tab[data-tab="' + target + '"]');
          if (tabBtn) tabBtn.classList.add('customizer-tab--active');
          var tabContent = document.getElementById('tab-' + target);
          if (tabContent) tabContent.classList.add('customizer-tab-content--active');
        } else if (target === 'options') {
          document.querySelector('.customizer-panel--right').classList.add('mobile-visible');
          document.querySelector('.customizer-canvas-area').classList.add('mobile-hidden');
        }
      });
    });
  }

  /* --- Boot --- */
  function waitForFabric() {
    if (typeof fabric !== 'undefined' && fabric.Canvas) { init(); }
    else { setTimeout(waitForFabric, 100); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', waitForFabric); }
  else { waitForFabric(); }
})();
